<template>
  <!-- <transition name="updown"> -->
  <div id="Login" v-if="LoginShow">
    <div class="mask"></div>
    <div class="KeyEnterLoading" v-show="keydownLoading">
      <div class="mask-one"></div>
      <div class="LoadingMid">
        <div class="sk-fading-circle">
          <div class="sk-circle1 sk-circle"></div>
          <div class="sk-circle2 sk-circle"></div>
          <div class="sk-circle3 sk-circle"></div>
          <div class="sk-circle4 sk-circle"></div>
          <div class="sk-circle5 sk-circle"></div>
          <div class="sk-circle6 sk-circle"></div>
          <div class="sk-circle7 sk-circle"></div>
          <div class="sk-circle8 sk-circle"></div>
          <div class="sk-circle9 sk-circle"></div>
          <div class="sk-circle10 sk-circle"></div>
          <div class="sk-circle11 sk-circle"></div>
          <div class="sk-circle12 sk-circle"></div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <h3 class="clearfix">
        <span class="title-inner"
          ><img src="../../assets/icon/image_instagram_icon@3x.png" alt="" /><i
            >Enter your Instagram username</i
          ></span
        >
        <a @click="closeLogin" class="close-img"
          ><img src="../../assets/icon/getz_push_close.png" alt=""
        /></a>
      </h3>
      <!-- <input type="text" name="" placeholder="Instagram username"> -->
      <div class="searchInputWrappe">
        <!-- <div placeholder="Instagram username" class="sp" v-model="searchInput" :keyEnterFun="clickConfirm" position="absolute" cancelText="cancel" @on-focus="scrollToTop" ></div> -->
        <input
          type="text"
          name=""
          value=""
          placeholder="Instagram username (not email, no password required)"
          autofocus
          @keyup.enter="keyEnterFun"
          @focus="hideLogo"
          @blur="showLogo"
          v-model="searchInput"
          ref="input"
          @keyup="onKeyUp"
          :class="{ active: changing }"
        />
        <a @click="emptyInput" v-show="clearShow"
          ><img src="../../assets/icon/getz_searchfriendsbox_close.png" alt=""
        /></a>
      </div>
      <a
        class="confirm-button"
        @click="clickConfirm"
        :class="{ active: searchInput != '' && confirmOnoff == false }"
        :disabled="confirmOnoff"
      >
        <span>Get Started</span>
      </a>
      <div class="please">
        <p>
          <span>Please make sure you aren't using a private profile.&nbsp</span
          ><a @click="detailShow">See more >></a>
        </p>
      </div>
      <div class="bottom-img" v-show="bottomLogo">
        <img src="../../assets/icon/image_logo@3x(5).png" alt="" />
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
export default {
  components: {},
  mounted() {
    // setTimeout(() => {
    //   // this.$refs.input.scrollIntoView(true);
    //   this.$refs.input.focus();
    // }, 3000)
  },
  computed: {
    userInfoMsg() {
      return this.$store.state.userInfo;
    },
    settingData() {
      return this.$store.state.settingData;
    },
    changing() {
      if (this.searchInput.split("").length > 0) {
        return true;
      } else {
        return false;
      }
    },
    LoginShow() {
      return this.$store.state.web_login_show;
    },
    clearShow() {
      if (this.searchInput.split("").length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      historyShow: false,
      searchInput: "",
      confirmOnoff: false,
      toastShow: false,
      historyData: [],
      historyBgShow: false,
      keydownLoading: false,
      bottomLogo: true
    };
  },
  methods: {
    hideLogo() {
      this.bottomLogo = false; //onFocus后隐藏logo 避免往上顶
    },
    showLogo() {
      setTimeout(() => {
        this.bottomLogo = true; //安卓机型会让底部的lgo往上顶 造成遮住input
      }, 1200);
    },
    detailShow() {
      this.$store.commit("updateLoginDetailShow", {
        web_login_detail_show: true
      });
    },
    closeLogin() {
      this.$store.commit("updateLoginShow", {
        web_login_show: false
      });
    },
    clickHis() {
      this.historyShow = !this.historyShow;
      if (this.getUserslocalStorage() != null) {
        var arr = this.getUserslocalStorage();
        if (arr.length == 0) {
          this.historyBgShow = true;
        }
        this.historyData = this.getUserslocalStorage(); //存在历史记录
      } else {
        this.historyBgShow = true;
      }
    },
    keyEnterFun() {
      // this.$store.dispatch('updateMidLoadingShow', {
      //   midLoadingShow: true,
      //   midLoadingText: ""
      // })
      this.clickConfirm();
      return;
    },
    onFocus() {
      // setTimeout(() => {
      //   this.$refs.input.scrollIntoView(true);
      // }, 400)
    },
    onKeyUp() {
      this.searchInput = this.searchInput.replace(/(^\s*)|(\s*$)/g, "");
    },
    emptyInput() {
      this.searchInput = "";
    },
    clickConfirm() {
      ga("send", {
        hitType: "event",
        eventCategory: "search_user_by_click",
        eventAction: "click"
      });

      this.$store.dispatch("updateMidLoadingShow", {
        midLoadingShow: true,
        midLoadingText: ""
      });
      if (this.searchInput != "" && this.confirmOnoff == false) {
        this.confirmOnoff = true; //禁止重复点击
        var that = this;
        this.updateUsersInfoByUserName(
          this.searchInput,
          function() {
            if (that.userInfoMsg.hasOwnProperty("err")) {
              that.confirmOnoff = false; //禁止重复点击
              return;
            }
            that.$store.commit("updateLoginShow", {
              web_login_show: false
            });
            that.$router.push({
              path:
                "/follow/" +
                that.userInfoMsg.user.username +
                "/" +
                that.userInfoMsg.user.id
            });
            if (JSON.stringify(that.$store.state.userInfo) != "{}") {
              var obj = {
                userName: that.$store.state.userInfo.user.username,
                userId: that.$store.state.userInfo.user.id,
                userPic: that.$store.state.userInfo.user.profile_pic_url
              };
              if (that.isLocalStorage()) {
                //如果支持
                that.setUserslocalStorage(obj);
              }
            }

            location.reload();
          },
          function() {
            that.toastShow = !that.toastShow;
            setTimeout(function() {
              that.confirmOnoff = false; //禁止重复点击
            }, 2500);
          }
        );
      } else if (this.searchInput == "") {
        this.$store.dispatch("updateMidLoadingShow", {
          midLoadingShow: false,
          midLoadingText: ""
        });
      } else {
        return false;
      }
    },
    maskClick() {
      this.historyShow = false;
    },
    historyClick() {
      this.historyShow = !this.historyShow;
      if (this.getUserslocalStorage() != null) {
        var arr = this.getUserslocalStorage();
        if (arr.length == 0) {
          this.historyBgShow = true;
        }
        this.historyData = this.getUserslocalStorage(); //存在历史记录
      } else {
        this.historyBgShow = true;
      }
    },
    deleteHistory(item) {
      if (confirm("Are you sure to clear?")) {
        this.deleteUserslocalStorage(item);

        this.historyData = this.getUserslocalStorage();

        if (this.historyData.length == 0) {
          this.historyBgShow = false;
          this.$route.push({
            path: "/follow/&/&"
          });
          location.reload();
        }
      }
    },
    selectHistory(item) {
      let username = item.userName;
      var that = this;
      this.$store.dispatch("updateMidLoadingShow", {
        midLoadingShow: true,
        midLoadingText: ""
      });
      this.updateUsersInfoByUserName(
        username,
        function() {
          that.$store.dispatch("updateMidLoadingShow", {
            midLoadingShow: false,
            midLoadingText: ""
          });
          that.$router.push({
            path: "/follow/" + username + "/" + item.userId
          }); //跳转loginConfirm
        },
        function() {
          that.toastShow = !that.toastShow;
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
#Login {
  background: rgb(248, 248, 248);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 500;
  .top {
    width: 100%;
    height: 40px;
    background: linear-gradient(to right, #1e2022, #414449);
    position: relative;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;
  }
  .mask-one {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1004;
  }
  .KeyEnterLoading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1004;
    .LoadingMid {
      width: 40px;
      height: 40px;
      position: fixed;
      top: 10%;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 1005;
    }
  }
}

main {
  height: 200px;
  width: 100%;
  background: linear-gradient(to right, #1e2022, #414449);
  position: relative;
  overflow: hidden;
  &:after {
    display: block;
    content: "";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid #fff;
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  img {
    display: block;
    width: 260px;
    height: auto;
    margin: 10px auto 0;
  }
}
.bottom {
  position: fixed;
  top: 98px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  background: #fff;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  width: 100%;
  box-sizing: border-box;
  .bottom-img {
    position: absolute;
    left: 50%;
    top: 66%;
    transform: translate(-50%, -50%);
    width: 100%;
    img {
      display: block;
      width: 80%;
      margin: 0 auto;
    }
  }
  .searchInputWrappe {
    position: relative;
    margin-bottom: 15px;
    .sp {
      .weui-search-bar {
        background: #000;
      }
    }
    a {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translate(0, -50%);
      display: block;
      width: 40px;
      height: 40px;
      img {
        display: block;
        width: 14px;
        height: 14px;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
      }
    }
  }
  .please {
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    margin-top: 14px;
    p {
      font-size: 12px;
      color: rgb(117, 116, 123);
      line-height: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      span {
        display: block;
      }
      a {
        display: block;
      }
    }
    a {
      color: rgb(0, 170, 238);
    }
  }
  h3 {
    font-size: 16px;
    color: rgb(39, 38, 54);
    line-height: 20px;
    font-weight: bold;
    margin: 19px 0 15px;
    .title-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-style: normal;
        font-size: 16px;
        font-weight: bold;
      }
      img {
        display: block;
        width: 20px;
        height: auto;
        margin-right: 8px;
      }
    }
    .close-img {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      width: 44px;
      height: 50px;
      img {
        display: block;
        position: absolute;
        left: 50%;
        top: 62%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 14px;
        height: auto;
      }
    }
  }
  input {
    display: block;
    width: 100%;
    height: 44px;
    background: #fff;
    border-radius: 3px;
    line-height: 14px;
    padding-left: 14px;
    box-sizing: border-box;
    font-size: 12px;
    margin-bottom: 15px;
    border: 1px solid rgb(221, 221, 221);
    color: rgb(166, 166, 166);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2) inset;
  }
  input.active {
    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
    color: rgb(39, 38, 54);
  }
  input:focus {
    border-color: rgba(0, 170, 238, 1);
  }
  padding: 0 15px 40px;
  .confirm-button {
    background: rgba(0, 170, 238, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    width: 100%;
    border: none;
    position: relative;
    span {
      display: block;
      font-size: 16px;
      height: 16px;
      line-height: 16px;
      font-weight: bold;
    }
    img {
      display: block;
      width: 14px;
      height: auto;
      margin-left: 8px;
    }
  }
  .confirm-button.active {
    background: rgba(0, 170, 238, 1);
  }
}

@media (max-width: 360px) {
  .bottom h3 .title-inner i {
    font-size: 14px;
  }
  .bottom .please p {
    font-size: 10px;
  }
}

.updown-enter-active {
  animation: slide-up 0.5s;
  animation-fill-mode: forwards;
}
.updown-leave-active {
  animation: slide-down 0.5s;
  animation-fill-mode: forwards;
}
@keyframes slide-up {
  0% {
    transform: translate3d(0, 100%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slide-down {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 100%, 0);
  }
}

.sk-fading-circle {
  width: 40px;
  height: 40px;
  position: relative;
}

.sk-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.sk-fading-circle .sk-circle:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #fff;
  border-radius: 100%;
  -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
  animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  transform: rotate(30deg);
}
.sk-fading-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  transform: rotate(60deg);
}
.sk-fading-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.sk-fading-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  transform: rotate(120deg);
}
.sk-fading-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
  -ms-transform: rotate(150deg);
  transform: rotate(150deg);
}
.sk-fading-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.sk-fading-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
  -ms-transform: rotate(210deg);
  transform: rotate(210deg);
}
.sk-fading-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
  -ms-transform: rotate(240deg);
  transform: rotate(240deg);
}
.sk-fading-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.sk-fading-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
  -ms-transform: rotate(300deg);
  transform: rotate(300deg);
}
.sk-fading-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
  transform: rotate(330deg);
}
.sk-fading-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.sk-fading-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.sk-fading-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
.sk-fading-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
.sk-fading-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.sk-fading-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
.sk-fading-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
.sk-fading-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
.sk-fading-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}
@-webkit-keyframes sk-circleFadeDelay {
  0%,
  100%,
  39% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
@keyframes sk-circleFadeDelay {
  0%,
  100%,
  39% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?1ca8d152